import { useTranslation } from "@redotech/redo-i18n";
import {
  MerchantCarrierAccountsSection,
  type MerchantCarrierAccountsSectionProps,
} from "./merchant-carrier-accounts-section";
import { RateSourceSelectionCard } from "./rate-source-selection-card";
import {
  RedoCarrierAccountsSection,
  type RedoCarrierAccountsSectionProps,
} from "./redo-carrier-accounts-section";

interface CarrierAccountsCardProps {
  /** Absent when the team's label mode leaves no Redo choice to make. */
  redo?: RedoCarrierAccountsSectionProps;
  /** Absent until the team has connected carrier accounts (or is loading them). */
  merchant?: MerchantCarrierAccountsSectionProps;
}

export function CarrierAccountsCard({
  redo,
  merchant,
}: CarrierAccountsCardProps) {
  const { t } = useTranslation();

  return (
    <RateSourceSelectionCard title={t("Carrier accounts")}>
      {redo && <RedoCarrierAccountsSection {...redo} />}
      {merchant && <MerchantCarrierAccountsSection {...merchant} />}
    </RateSourceSelectionCard>
  );
}
